import Login from './views/Login.vue'
import NotFound from './views/404.vue'
import student from './views/admin/Student.vue'
import teacher from './views/admin/Teacher.vue'
import ta from './views/admin/Ta.vue'
import bin from './views/admin/Trash.vue'
import relation from './views/admin/Relation.vue'
import trip from './views/admin/Trip.vue'
import report from './views/student/Report.vue'
import evidence from './views/student/Evidence.vue'
import progress from './views/teacher/Progress.vue'
import teacherRelation from './views/teacher/TeacherRelation.vue'
import notification from './views/Notification.vue'

import home from './views/Home.vue'

let routes = [
    {
        path: '/login',
        component: Login,
        alias: '/',
        name: '',
    },
    // TODO: logout refactor
    // { path: '/logout',
    //     beforeEnter (to, from, next) {
    //         // auth.logout()
    //         next('/')
    //     }
    // },
    {
        path: '/404',
        component: NotFound,
        name: '',
    },
    {
        path: '/notification',
        component: notification,
        name: '',
    },
    {
        path: '/admin',
        component: home,
        meta: {role: 'admin'},
        children: [
            {path: 'student', component: student, name: 'Student', iconCls: 'icon ion-person-stalker'},
            {path: 'sa', component: teacher, name: 'SA', iconCls: 'icon ion-person'},
            {path: 'ta', component: ta, name: 'TA', iconCls: 'icon ion-person'},
            {path: 'bin', component: bin, name: 'Bin', iconCls: 'icon ion-trash-a'},
            {path: 'relation', component: relation, name: 'Relation', iconCls: 'icon ion-network'},
            {path: 'trip', component: trip, name: 'Trip', iconCls: 'icon ion-plane'},
        ]
    },
    {
        path: '/student',
        component: home,
        meta: {role: 'student'},
        children: [
            {path: 'cope', component: report, name: 'EPQ', iconCls: 'icon ion-university',},
            {path: 'aope', component: report, name: 'LOG', iconCls: 'icon ion-university',},
            {path: 'cope/evidence', component: evidence, name: 'CoPEEvidence', iconCls: 'icon ion-university', hiddenFromMenu: true},
            {path: 'aope/evidence', component: evidence, name: 'AoPEEvidence', iconCls: 'icon ion-university', hiddenFromMenu: true}

        ]
    },
    {
        path: '/teacher',
        component: home,
        meta: {role: 'teacher'},
        children: [
            {path: 'progress', component: progress, name: 'Student Progress', iconCls: 'icon ion-university',},
            // {path: 'relation', component: teacherRelation, name: 'Manage Relations', iconCls: 'icon ion-university',},
            {path: 'progress/evidence', component: evidence, name: 'TeacherEvidence', iconCls: 'icon ion-university', hiddenFromMenu: true}
        ]
    },
    {
        path: '/ta',
        component: home,
        meta: {role: 'ta'},
        children: [
            {path: 'progress', component: progress, name: 'Student Progress', iconCls: 'icon ion-university',},
            // {path: 'relation', component: teacherRelation, name: 'Manage Relations', iconCls: 'icon ion-university',},
            {path: 'progress/evidence', component: evidence, name: 'TeacherEvidence', iconCls: 'icon ion-university', hiddenFromMenu: true}
        ]
    },
    {
        path: '*',
        redirect: {path: '/404'},
    }
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js